import { Injectable } from '@angular/core';
import { Base } from '../models/base';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  private _info: Base = {
    indexUrl: '',
    browserRefresh: true,
    preStep: 1,
  };

  get info() { return this._info }

  set info(value) {
    ({ info: this._info } = { info: value });
  }

  constructor(
    private router: Router,
  ) { }

  detectBrowserRefresh(): boolean {
    if ( this.info.browserRefresh ) {
      this.router.navigateByUrl(this.router.url.replace(/step[2,3]/, 'step1'))
    }
    this.info.browserRefresh = true;
    return this.info.browserRefresh;
  }
}
